import React from "react";
import { Grid } from "semantic-ui-react";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import SearchableDropdown from "@EUForms/searchableDropdown";
import DeleteIcon from "@commonComponents/deleteIcon";
import { confirmAlert } from "react-confirm-alert";

const CustomOfficeForm = (props) => {
  const {
    dataSource: { id, type = "", office },
    isTypeDisabled = false,
    isDeleteBtnDisabled = false,
    isDisabled,
    isOfficeTypeAleadyExist,
    tableName,
    onSelect,
    deleteData,
    onBlur,
    onChange,
    customOfficeTypeList,
    inputType,
    officeNameList = []
  } = props
  const onDropDownChange = (e, { value, name }) => {

    if (name == "office")
      onSelect(id, tableName, { [name]: value, id, type })
    else {
      if (isOfficeTypeAleadyExist(value))
        confirmAlert({ message: `Only 1 of type ${value} is allowed`, buttons: [{ label: 'OK' }] })

      else {
        onChange(id, tableName, { [name]: value, id, office: "" })
        onBlur(tableName, { [name]: type || value, id, office: "" })
      }
    }
  }

  const isTypeGUA = type == "GUA"
  const filteredCustomOfficeList = React.useMemo(() => {
    if (officeNameList.length == 0 || isTypeGUA || !type) return []

    return officeNameList.filter(c => c.additionalInfo?.split(',').includes(type))
  }, [officeNameList, type, isTypeGUA]
  )

  return (
    <div className="formContainer">
      <Grid.Row>
        <Grid.Column>
          <DropDown
            id={`${tableName}-${id}-type`}
            label="TYPE"
            labelClass="text-none"
            name="type"
            data={customOfficeTypeList}
            value={type}
            text={type}
            onChange={onDropDownChange}
            isDisabled={isDisabled || isTypeDisabled}
          />
        </Grid.Column>
        <Grid.Column>
          {inputType == "dropdown" && !isTypeGUA ?
            <DropDown
              id={`${tableName}-${id}-office`}
              label="OFFICE_NAME"
              labelClass="text-none"
              name="office"
              value={office}
              text={office}
              isDisabled={type ? null : true}
              data={filteredCustomOfficeList}
              clearable
              onChange={onDropDownChange}
            />
            :
            <SearchableDropdown
              id={`${tableName}-${id}-office`}
              label="OFFICE_NAME"
              name="office"
              dropdownType={`customOffice${type == "EXPORT" ? "Export" : ""}`}
              selectedValue={office}
              onSelect={({ value }) => onDropDownChange(null, { value, name: "office" })}
              disabled={type ? false : true}
              onBlur={({ value }) => {
                if (!value) {
                  onDropDownChange(null, { value, name: "office" })
                }
              }}

            />}
        </Grid.Column>
      </Grid.Row>
      <div className="actionbtns">
        <DeleteIcon onClick={async () => {
          if (type) {
            const response = await onBlur(tableName, { id, type, office: " " })
            if (response)
              deleteData({ id, tableName })
          }
          else
            deleteData({ id, tableName })
        }}
          isDisabled={isDisabled || isDeleteBtnDisabled}
        />
      </div>
    </div>
  );
}

export default React.memo(CustomOfficeForm)
